import { ListboxOption, StandardCombobox } from '@brandfolder/react';

import React, { FunctionComponent, useEffect, useState } from 'react';

import { useFetch } from '@api/ApiHelper';
import { ApiDataResponse } from '@api/v4/ApiResponseTypes';
import { CollectionServer } from '@api/v4/collections';
import { Brandfolder } from '@mocks/api/v4/brandfolders';

import { ResourceType } from './BrandguideCreateForm';

import classes from './styles/brandguide-combobox.module.scss';

interface BrandguidesComboboxProps {
  organizationKey: string;
  setResourceKey: React.Dispatch<React.SetStateAction<string>>,
  type: ResourceType;
}

export const BrandguidesCombobox: FunctionComponent<BrandguidesComboboxProps> = ({ organizationKey, setResourceKey, type }) => {
  const [options, setOptions] = useState<ListboxOption[]>([]);
  const {
    error: brandfoldersError,
    fetch: brandfoldersFetch,
    loading: brandfoldersLoading,
    response: brandfoldersResponse
  } = useFetch<ApiDataResponse<Brandfolder, 'brandfolders'>>({
    fetchOnMount: false,
    url: `/api/v4/organizations/${organizationKey}/brandfolders`
  });

  const {
    error: collectionsError,
    fetch: collectionsFetch,
    loading: collectionsLoading,
    response: collectionsResponse
  } = useFetch<ApiDataResponse<CollectionServer, 'collections'>>({
    fetchOnMount: false,
    url: `/api/v4/organizations/${organizationKey}/collections?is_workspace=false&per=3000`
  });

  useEffect(() => {
    if (type === 'brandfolder') {
      brandfoldersFetch();
    } else {
      collectionsFetch();
    }
  }, [type]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (brandfoldersResponse) {
      setOptions([
        ...brandfoldersResponse?.data.map((brandfolder) => {
          return {
            children: brandfolder.attributes.name,
            key: brandfolder.id,
            value: brandfolder.id
          };
        })
      ]);
    }
  }, [brandfoldersResponse]);

  useEffect(() => {
    if (collectionsResponse) {
      setOptions([
        ...collectionsResponse?.data.map((collection) => {
          return {
            children: collection.attributes.name,
            key: collection.id,
            value: collection.id
          };
        })
      ]);
    }
  }, [collectionsResponse]);

  return (
    <StandardCombobox
      id={`${type}-options`}
      labels={{
        iconButtonLabel: type === 'brandfolder' ?  bfTranslate('Toggle Brandfolders') : bfTranslate('Toggle Collections'),
        label: type === 'brandfolder' ?  bfTranslate('Choose a Brandfolder') : bfTranslate('Choose a Collection'),
        listboxLabel: type === 'brandfolder' ?  bfTranslate('List of Brandfolders') : bfTranslate('List of Collections'),
        loaderLabel: bfTranslate('Loading'),
        requiredLabel: bfTranslate('Required')
      }} 
      loading={type === 'brandfolder' ? brandfoldersLoading : collectionsLoading}
      onSelection={(option): void => {
        setResourceKey(option.value as string);
      }}
      optionProps={{ className: classes.brandguideOptions, index: null, onSelected: null, option: null }}
      options={[{ 
        children: null, 
        key: 0, 
        placeholder: type === 'brandfolder' ?  bfTranslate('Choose a Brandfolder') : bfTranslate('Choose a Collection'), 
        value: '' }, 
      ...options
      ]}
      required
      showLabel={false}
    />
  );
};